module.exports = __webpack_public_path__ + "static/media/vietnam-icon.fa2d1147.svg";